import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, MessageCircle, Shield, Edit3, AlertTriangle } from 'lucide-react';
const deliverables = [{
  icon: BookOpen,
  title: 'Guía paso a paso',
  desc: 'Qué hacer exactamente desde el Día 1 al Día 7. Sin adivinanzas.'
}, {
  icon: MessageCircle,
  title: 'Scripts de comunicación',
  desc: 'Frases exactas para responder a sus desafíos sin perder la calma.'
}, {
  icon: Shield,
  title: 'La técnica de la Roca Calma',
  desc: 'El método probado para que sus gritos y actitudes no te afecten emocionalmente.'
}, {
  icon: Edit3,
  title: 'Hojas de trabajo diarias',
  desc: 'Ejercicios breves para identificar tus gatillos de enojo y neutralizarlos.'
}, {
  icon: AlertTriangle,
  title: 'Guía de emergencia',
  desc: 'Qué decir y hacer en ese segundo exacto donde sientes que vas a explotar.'
}];
export function WhatYouGetSection() {
  return <section className="py-10 md:py-24 bg-maternal-beige" data-id="element-265">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-266">
        <div className="text-center mb-10 md:mb-16" data-id="element-267">
          <h2 className="text-3xl md:text-4xl font-bold text-maternal-brown mb-4" data-id="element-268">
            Todo lo que necesitas para recuperar la paz
          </h2>
          <p className="text-lg text-maternal-lightBrown" data-id="element-269">
            Un arsenal completo de herramientas prácticas, directas y fáciles de
            aplicar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-270">
          {deliverables.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white p-8 rounded-2xl shadow-md border border-maternal-cream hover:shadow-lg transition-shadow duration-300 flex flex-col items-center text-center" data-id="element-271">
                <div className="w-16 h-16 bg-maternal-cream rounded-full flex items-center justify-center mb-6 text-maternal-amber" data-id="element-272">
                  <Icon className="w-8 h-8" data-id="element-273" />
                </div>
                <h3 className="text-xl font-bold text-maternal-brown mb-3" data-id="element-274">
                  {item.title}
                </h3>
                <p className="text-maternal-lightBrown leading-relaxed" data-id="element-275">
                  {item.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}